import 'reflect-metadata'; // This import *"MUST"* be on first line

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { BOOTSTRAP_CONFIG } from './app/app.config';

(async () => {
  try {
    const appRef = await bootstrapApplication(AppComponent, BOOTSTRAP_CONFIG);
    // optionally keep the ApplicationRef around for debugging
    (window as any).appRef = appRef;
  } catch (err) {
    console.error('BootstrapApplication error:', err);
    if (err instanceof Error) {
      console.error(err.stack);
    }
    // Show it on screen
    document.body.innerHTML = `<pre style="white-space: pre-wrap; color: red;">
         ${err instanceof Error ? err.stack : String(err)}
       </pre>`;
  }
})();
